import { FC, useState } from 'react'
import mclasses from '@pages/Admin/CRM/styles/modal.module.css'
import classes from './index.module.css'
import Modal from '@common/Modal'
import { IcoRemove } from '@/utils/icons'
import { IcoDownload } from '@/utils/icons'
import cn from 'classnames'
import FinancialTransactionsReport from '../FinancialTransactionsReport/FinancialTransactionsReport'
import Button from '@UI/New/Button'
import { useDownloadFile } from '@/hooks/useDownloadFile'
import { directionOrdersApi } from '@/api'
import { IFilters } from '../FinancialTransactionsReport/FinancialTransactionsReport'

interface FinancialTransactionsReportModalProps {
  userId: number
  open: boolean
  onClose: () => void
}

const ModalContent: FC<FinancialTransactionsReportModalProps> = ({
  userId,
  onClose,
}) => {
  const { download, loading } = useDownloadFile()
  const [filters, setFilters] = useState<IFilters>({
    directionId: null,
    status: null,
  })

  const handleDownloadExcel = () => {
    download({
      request: () =>
        directionOrdersApi.getHistoryExcel({
          id: userId,
          ...(filters.directionId
            ? { direction_id: filters.directionId }
            : {}),
          ...(filters.status ? { status: filters.status } : {}),
        }),
      name: 'История списаний и начислений',
      alertText: 'Файл скачан',
    })
  }

  return (
    <div className={mclasses.modalContainer}>
      <div className={mclasses.modalHeader}>
        <div className={mclasses.modalTitleContainer}>
          <span className={mclasses.modalHeaderTitle}>История списаний и начислений</span>
        </div>
        <div className={classes.headerActions}>
          <Button
            color="gray"
            onClick={handleDownloadExcel}
            disabled={loading}
            isLoading={loading}
            leftContent={<IcoDownload style={{ transform: 'rotate(180deg)' }} />}
          >
            Скачать Excel
          </Button>
          <div className={mclasses.closeIcon} onClick={() => onClose()}>
            <IcoRemove />
          </div>
        </div>
      </div>
      <div className={cn(mclasses.formWrapper, classes.formWrapper)}>
        <div className={cn(classes.list, 'customScroll')}>
          <FinancialTransactionsReport
            userId={userId}
            filters={filters}
            setFilters={setFilters}
            showDownload={false}
          />
        </div>
      </div>
    </div>
  )
}

const FinancialTransactionsReportModal: FC<
  FinancialTransactionsReportModalProps
> = (props) => {
  const { open, onClose } = props

  return (
    <Modal
      active={open}
      className={cn(mclasses.modalWrapper, classes.modalWrapper) as any}
      setActive={() => onClose()}
    >
      <ModalContent {...props} />
    </Modal>
  )
}

export default FinancialTransactionsReportModal
